export default __webpack_public_path__ + "static/media/incoming.2997d215.png";